import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ComplaintsPolicyComp = () => {
    return (
        <div className="min-h-screen flex justify-center items-start">
            <div className="m-5 w-full max-w-3xl bg-gradient-to-br from-black/70 to-purple-900/40 rounded-3xl shadow-2xl p-6 md:p-10 border border-red-700/40 backdrop-blur-md animate-fade-in transition-all">
                <div className="flex flex-col items-center mb-8">
                    <ExclamationTriangleIcon className="h-10 w-10 text-red-400 mb-2" />
                    <h1 className="text-center text-2xl md:text-3xl font-bold text-white tracking-wide mb-1">ErotixAI Complaints Policy</h1>
                    <div className="flex flex-col items-center text-center text-xs md:text-sm text-red-200 space-y-1">
                        <span>Last Updated: <span className="font-semibold">June 24, 2025</span></span>
                    </div>
                </div>
                <div className="prose prose-invert max-w-none text-white/90 text-sm md:text-base leading-relaxed">
                    <section>
                        <h2 className="text-lg font-semibold text-red-300 mb-1">1. Purpose</h2>
                        <p>At ErotixAI, we are committed to providing high-quality, respectful, and safe AI-based experiences. We take all complaints seriously and are dedicated to resolving them fairly, promptly, and confidentially.</p>
                        <p>This policy outlines how complaints can be raised, how they will be handled, and our commitment to timely resolution.</p>
                    </section>
                    <section>
                        <h2 className="text-lg font-semibold text-red-300 mb-1">2. Scope</h2>
                        <p>This policy applies to:</p>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Users of ErotixAI services or platforms</li>
                            <li>Business partners, collaborators, or vendors</li>
                            <li>Individuals affected by our content or service operations</li>
                        </ul>
                        <p>Complaints may relate to:</p>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Offensive, inappropriate, or unauthorized content</li>
                            <li>Technical issues or bugs</li>
                            <li>Ethical concerns involving AI interaction</li>
                            <li>Privacy violations or legal issues</li>
                            <li>Misconduct by ErotixAI staff or representatives</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="text-lg font-semibold text-red-300 mb-1">3. How to Submit a Complaint</h2>
                        <p>Complaints can be submitted through the following channels:</p>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Email: <a href="mailto:support@erotixai.com" className="underline">support@erotixai.com</a></li>
                            <li>Contact Form: <a href="https://erotixai.com/contact-us" className="underline">erotixai.com/contact-us</a></li>
                            <li>In-App Reporting: Use the "Report" or "Feedback" function inside the platform</li>
                        </ul>
                        <p>Please include:</p>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Your contact information (optional for anonymous feedback)</li>
                            <li>Description of the issue</li>
                            <li>Date/time of occurrence</li>
                            <li>Any supporting evidence (screenshots, logs, etc.)</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="text-lg font-semibold text-red-300 mb-1">4. Complaint Resolution Timeline</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Acknowledgment: Within 48 hours</li>
                            <li>Resolution: Within 7 days</li>
                        </ul>
                        <p>If, in rare and exceptional cases, more time is needed (e.g., legal involvement or third-party inquiries), we will notify you with an updated timeline.</p>
                    </section>
                    <section>
                        <h2 className="text-lg font-semibold text-red-300 mb-1">5. Complaint Handling Process</h2>
                        <ol className="list-decimal list-inside space-y-1 ml-4">
                            <li>Review & Acknowledgment – We confirm receipt and assign a reference ID</li>
                            <li>Investigation – The issue is reviewed by the appropriate team</li>
                            <li>Resolution – An appropriate outcome is determined and actioned</li>
                            <li>Response – We notify you of the outcome and any relevant updates</li>
                        </ol>
                    </section>
                    <section>
                        <h2 className="text-lg font-semibold text-red-300 mb-1">6. Escalation</h2>
                        <p>If you are unsatisfied with the outcome, you may request that the matter be escalated to a senior compliance officer or manager. In legal cases, you have the right to refer the matter to relevant authorities or regulatory bodies.</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ComplaintsPolicyComp; 